














import Component from 'vue-class-component'
import { Vue, Watch } from 'vue-property-decorator'
import DeliveryForm from '@/components/delivery/DeliveryForm.vue'
import deliveryStore from '@/stores/DeliveryStore'
import Delivery from '@/dto/deliveries/Delivery'
import { Location } from 'vue-router'
import { Routes } from '@/router/routes'

@Component({
  components: { DeliveryForm },
})
export default class DeliveryEdit extends Vue {
  delivery: Delivery | null = null
  deliveryStore = deliveryStore

  setModel() {
    if (this.deliveryStore.deliveryId && this.deliveryStore.deliveries.length) {
      this.delivery = Object.assign({}, this.deliveryStore.delivery)
    }
  }

  get deliveriesRoute(): Location {
    return { name: Routes.deliveries }
  }

  @Watch('deliveryStore.deliveries', { immediate: true })
  onChangeDeliveries() {
    if (this.delivery === null) {
      this.setModel()
    }
  }

  @Watch('deliveryStore.deliveryId', { immediate: true })
  onChangeDelivery() {
    this.setModel()
  }

  @Watch('deliveryStore.delivery.enabled')
  syncEnabled(value: boolean) {
    if (this.delivery) {
      this.delivery.enabled = value
    }
  }
}
